import type { ContractPrintView } from "@buildpy/core/views/g2a/contract-print";
import A4Fit from "@/modules/print/a4-fit";
import ContractDocument from "@/modules/print/contract-document";
import PrintPreviewShell from "@/modules/print/print-preview-shell";

// 인쇄 계약서 — 같은 조직 멤버만, 체결본은 스냅샷에서 찍는다.
const Page = ({ data }: { data: ContractPrintView }) => {
  const { contract, model } = data;

  return (
    <PrintPreviewShell
      closeHref={`/app/contracts/${contract.id}`}
      subtitle={contract.title}
      title={`계약 ${model.contract_no} · ${model.status_label}`}
    >
      <A4Fit>
        <ContractDocument model={model} />
      </A4Fit>
    </PrintPreviewShell>
  );
};

export default Page;
